export default "__VITE_ASSET__Bd6l1dq9__"